// import React from 'react';
// import { Target, DollarSign, User, ClipboardCheck, Crosshair, Flag, Code, FileText } from 'lucide-react';

// const WhyChooseUs = () => {
//   // Define hex color codes
//   const colors = {
//     primaryPurple: "#2D1FD1", // Dark purple for primary elements
//     lightPurple: "#F3F1FF",   // Light purple for backgrounds
//     darkText: "#333333",      // Dark text color
//     white: "#FFFFFF",         // White color
//     borderGray: "#E5E7EB"     // Border color
//   };

//   // Define icons with their labels
//   const features = [
//     {
//       icon: <Target style={{ color: colors.primaryPurple }} className="w-12 h-12" />,
//       title: "Comprehensive Quality Assessment",
//     },
//     {
//       icon: <DollarSign style={{ color: colors.primaryPurple }} className="w-12 h-12" />,
//       title: "Competitive Pricing",
//     },
//     {
//       icon: <User style={{ color: colors.primaryPurple }} className="w-12 h-12" strokeWidth={1.5} />,
//       title: "Highly Skilled Team",
//     },
//     {
//       icon: <ClipboardCheck style={{ color: colors.primaryPurple }} className="w-12 h-12" />,
//       title: "Zero Defect Spill Rate",
//     },
//     {
//       icon: <Crosshair style={{ color: colors.primaryPurple }} className="w-12 h-12" />,
//       title: "Focused On Your Needs",
//     },
//     {
//       icon: <Flag style={{ color: colors.primaryPurple }} className="w-12 h-12" />,
//       title: "Experience Across",
//     },
//     {
//       icon: <Code style={{ color: colors.primaryPurple }} className="w-12 h-12" />,
//       title: "Robust Test Automation",
//     },
//     {
//       icon: <FileText style={{ color: colors.primaryPurple }} className="w-12 h-12" />,
//       title: "Transparent Reporting",
//     },
//   ];

//   return (
//     <div className="w-full" style={{ backgroundColor: colors.white }}>
      

//       {/* Main Content */}
//       <div className="container mx-auto px-4 py-12">
//         <h1 className="text-center text-4xl md:text-5xl font-bold mb-16">
//           <span style={{ color: colors.primaryPurple }}className='text-3xl' >Why Choose Us</span>{" "}
//           <span style={{ color: colors.darkText }} className='text-xl'>for Software Testing Services?</span>
//         </h1>

//         {/* Features Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
//           {features.map((feature, index) => (
//             <div key={index} className="flex flex-col items-center">
//               <div className="w-24 h-24 rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: colors.lightPurple }}>
//                 {feature.icon}
//               </div>
//               <h3 className="text-center font-medium text-lg" style={{ color: colors.darkText }}>{feature.title}</h3>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default WhyChooseUs;

import React, { useState } from 'react';

const WhyChooseUs = () => {
  const [hoveredFeature, setHoveredFeature] = useState(null);

  // Define color constants with hex codes
  const COLORS = {
    primary: "#6b2c91",      // Main violet
    secondary: "#f3e8ff",    // Light violet background
    accent: "#9333ea",       // Bright violet accent
    text: "#333333",         // Dark text
    lightText: "#666666",    // Light text
    background: "#f9fafb",   // Light background
    cardBg: "#ffffff",       // Card background
    headingBg: "#f0e6ff",    // Heading background
    headingUnderline: "#9333ea" // Heading underline
  };

  // Define features with image paths instead of icons
  const features = [
    {
      imagePath: "https://ik.imagekit.io/kqumni8l2/Testing%20page/Testing_Why%20Choose%20_us/Comprehensive-Quality-Assessment-by-a-QA-Company.webp?updatedAt=1747024760063",
      imageAlt: "Target icon",
      title: "Comprehensive Quality Assessment",
      description: "End-to-end testing across all aspects of your application with detailed quality metrics and reporting."
    },
    {
      imagePath: "https://ik.imagekit.io/kqumni8l2/Testing%20page/Testing_Why%20Choose%20_us/QA-Testing-Services-at-Competitive-Pricing.webp?updatedAt=1747024760696",
      imageAlt: "Dollar sign icon",
      title: "Competitive Pricing",
      description: "Flexible pricing models tailored to your project needs with transparent cost structure and no hidden fees."
    },
    {
      imagePath: "https://ik.imagekit.io/kqumni8l2/Testing%20page/Testing_Why%20Choose%20_us/Highly-Skilled-Quality-Assurance-Team.webp?updatedAt=1747024760349",
      imageAlt: "User icon",
      title: "Highly Skilled Team",
      description: "Certified testing professionals with extensive experience across various industries and technologies."
    },
    {
      imagePath: "https://ik.imagekit.io/kqumni8l2/Testing%20page/Testing_Why%20Choose%20_us/Zero-Defect-Spill-Rate.webp?updatedAt=1747024760256",
      imageAlt: "Clipboard check icon",
      title: "Zero Defect Spill Rate",
      description: "Our rigorous testing methodology ensures no critical defects make it to production environments."
    },
    {
      imagePath: "https://ik.imagekit.io/kqumni8l2/Testing%20page/Testing_Why%20Choose%20_us/QA-Outsourcing-Services-Focused-on-Your-Needs.webp?updatedAt=1747024760276",
      imageAlt: "Crosshair icon",
      title: "Focused On Your Needs",
      description: "Customized testing strategies aligned with your business goals and technical requirements."
    },
    {
      imagePath: "https://ik.imagekit.io/kqumni8l2/Testing%20page/Testing_Why%20Choose%20_us/A-QA-Outsourcing-Company-with-Experience-Across-Industries.webp?updatedAt=1747024760072",
      imageAlt: "Flag icon",
      title: "Experience Across Industries",
      description: "Domain expertise spanning healthcare, finance, retail, e-commerce, and many other sectors."
    },
    {
      imagePath: "https://ik.imagekit.io/kqumni8l2/Testing%20page/Testing_Why%20Choose%20_us/Robust-Test-Automation.webp?updatedAt=1747024760694",
      imageAlt: "Code icon",
      title: "Robust Test Automation",
      description: "Advanced automation frameworks that reduce testing time while increasing coverage and reliability."
    },
    {
      imagePath: "https://ik.imagekit.io/kqumni8l2/Testing%20page/Testing_Why%20Choose%20_us/A-QA-Company-That-Assures-Transparent-Reporting.webp?updatedAt=1747024760222",
      imageAlt: "File text icon",
      title: "Transparent Reporting",
      description: "Comprehensive test reports with clear metrics, insights, and actionable recommendations."
    },
  ];

  const handleFeatureHover = (index) => {
    setHoveredFeature(index);
  };

  const handleFeatureLeave = () => {
    setHoveredFeature(null);
  };

  return (
    <div className="w-full py-16" style={{ backgroundColor: COLORS.background }}>
      <div className="container mx-auto px-4">
        {/* Enhanced Header Section */}
        <div className="text-center mb-16">
          <div className="relative inline-block">
            <div className="absolute inset-0 bg-gradient-to-r from-purple-100 to-purple-200 transform -skew-y-3 rounded-2xl"></div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4 relative z-10 py-4 px-8">
              <span style={{ color: COLORS.primary }} className="text-3xl md:text-4xl">
                Why Choose Us
              </span>
              <span style={{ color: COLORS.text }}> for Software Testing Services?</span>
            </h1>
          </div>
          
          <div 
            className="mx-auto max-w-2xl rounded-lg py-4 px-6 mb-8 shadow-lg"
            style={{ backgroundColor: COLORS.headingBg }}
          >
            <p style={{ color:"black" }} className="text-xl text-center">
              Delivering Excellence in Quality Assurance
            </p>
          </div>
        </div>

        {/* Enhanced Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="flex flex-col items-center transform transition-all duration-300 hover:-translate-y-2 bg-white rounded-xl shadow-lg p-6 hover:shadow-xl"
              onMouseEnter={() => handleFeatureHover(index)}
              onMouseLeave={handleFeatureLeave}
              style={{
                // borderTop: `4px solid ${COLORS.primary}`,
                borderRadius: '16px',
                backgroundColor: hoveredFeature === index ? COLORS.secondary : COLORS.cardBg
              }}
            >
              <div 
                className="w-24 h-24 rounded-full flex items-center justify-center mb-6 shadow-md transition-all duration-300 overflow-hidden"
                style={{ 
                  backgroundColor: hoveredFeature === index ? COLORS.primary : COLORS.secondary,
                  boxShadow: hoveredFeature === index ? `0 10px 15px -3px ${COLORS.primary}40` : '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                }}
              >
                <img 
                  src={feature.imagePath} 
                  alt={feature.imageAlt}
                  className="w-16 h-16 object-contain transition-transform duration-300"
                  style={{
                    transform: hoveredFeature === index ? 'scale(1.1)' : 'scale(1)'
                  }}
                />
              </div>
              
              <div className="text-center">
                <h3 
                  className="font-semibold text-lg mb-3 transition-colors duration-300" 
                  style={{ color: hoveredFeature === index ? COLORS.primary : COLORS.text }}
                >
                  {feature.title}
                </h3>
                <p 
                  className="text-sm transition-all duration-500 ease-in-out" 
                  style={{ 
                    color: COLORS.lightText,
                    opacity: hoveredFeature === index ? 1 : 0.7,
                    maxHeight: hoveredFeature === index ? '100px' : '0',
                    overflow: 'hidden',
                  }}
                >
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
        
      
       
      </div>
    </div>
  );
};

export default WhyChooseUs;